///include /assets/js/plugins/notify.js

/**
 * We have used unique addStyle calls here because the icon is different in each
 * of the HTML snippets..
 */

$.notify.addStyle("success", {
    html: `<div>\n<i aria-hidden="true" class="far fa-check-circle"></i><span data-notify-html class="ms-2"></span>\n</div>`,
    classes: {
        green: {
            "font-size": "14px",
            "font-weight": "700",
            "padding": "20px",
            "border-radius": "8px",
            "white-space": "nowrap",
            "background-repeat": "no-repeat",
            "background-position": "3px 7px",
            "background-color": "#E1EFDB",
            "color": "#004D17",
            "max-width": "450px",

        },
    },
})

$.notify.addStyle("warning", {
    html: `<div>\n<i aria-hidden="true" class="far fa-exclamation-circle"></i><span data-notify-html class="ms-2"></span>\n</div>`,
    classes: {
        warning: {
            "font-size": "14px",
            "font-weight": "700",
            "padding": "20px",
            "border-radius": "8px",
            "white-space": "nowrap",
            "background-repeat": "no-repeat",
            "background-position": "3px 7px",
            "background-color": "#FFE9C1",
            "color": "#792809",
            "max-width": "450px",
        },
    },
})

$.notify.addStyle("fail", {
    html: `<div>\n<i aria-hidden="true" class="far fa-times-circle"></i><span data-notify-html class="ms-2"></span>\n</div>`,
    classes: {
        fail: {
            "font-size": "14px",
            "font-weight": "700",
            "padding": "20px",
            "border-radius": "8px",
            "white-space": "nowrap",
            "background-repeat": "no-repeat",
            "background-position": "3px 7px",
            "background-color": "#FFF5F6",
            "color": "#A20C1B",
            "max-width": "450px",
        },
    },
})

// This is the same as fail above except it takes HTML. ONLY to be called
// through an HTML-escaping wrapper.
$.notify.addStyle("fail-compiled", {
    html: `<div>\n<i aria-hidden="true" class="far fa-times-circle"></i><span data-notify-html class="ms-2" style="color:#A20C1B;"></span>\n</div>`,
    classes: {
        fail: {
            "font-size": "14px",
            "font-weight": "700",
            "padding": "20px",
            "border-radius": "8px",
            "white-space": "nowrap",
            "background-repeat": "no-repeat",
            "background-position": "3px 7px",
            "background-color": "#FFF5F6",
            "color": "#A20C1B",
            "max-width": "450px",
        },
    },
})

class ShowNotification {
    /**
     * notify.js builds each toast from nothing, and a live region that
     * arrives together with its text is not reliably read out. So every
     * message is also written into a hidden region that lives for the whole
     * page, which screen readers do announce (WCAG 4.1.3).
     *
     * @param {?string} message
     * @param {?string} additionalText
     * @param {boolean} urgent assertive (errors) rather than polite
     */
    static announce(message, additionalText, urgent) {
        const text = [message, additionalText].filter(t => t).join(". ")
        if(!text || !document.body) {
            return
        }
        const id = urgent ? "notify-live-assertive" : "notify-live-polite"
        let region = document.getElementById(id)
        if(!region) {
            region = document.createElement("div")
            region.id = id
            region.className = "visually-hidden"
            region.setAttribute("aria-live", urgent ? "assertive" : "polite")
            region.setAttribute("aria-atomic", "true")
            document.body.appendChild(region)
        }
        region.textContent = ""
        // Set on a later tick so a repeat of the same text is still a change.
        setTimeout(() => {
            region.textContent = text
        }, 100)
    }

    /**
     * Shows a success message
     * @param {string} message
     * @param {{close?: boolean, additionalText?: string} | null} [options]
     */
    static success(message, options = null) {
        /** @type {{style: string, className: string, autoHide?: boolean}} */
        const ob = {
            style: "success",
            className: "green",
        }

        if(options && options.close) {
            ob.autoHide = false
        }

        let message_compiled = $("<p>").append(
            $("<span>").attr("class", "text-wrap").css({"color":"#004D17"}).text(message || "")
        )

        if(options?.additionalText) {
            message_compiled = message_compiled.append(
                $("<div>")
                    .attr("class", "mt-2 text-wrap")
                    .css({
                        "font-weight": 400,
                        "word-wrap": "break-word",
                        "color": "#004D17"
                    })
                    .text(options.additionalText || "")
            )
        }

        message_compiled = message_compiled.html()

        ShowNotification.announce(message, options?.additionalText, false)

        // Notifyjs bug: if the first arg is undefined, it crashes.
        $.notify(message_compiled, ob)
    }

    /**
     * Shows a warning
     * @param {string} message
     * @param {{close?: boolean, additionalText?: string} | null} [options]
     */
    static warn(message, options = null) {
        /** @type {{style: string, className: string, autoHide?: boolean}} */
        const ob = {
            style: "warning",
            className: "warning",
        }

        if(options && options.close) {
            ob.autoHide = false
        }

        let message_compiled = $("<p>").append(
            $("<span>").attr("class", "text-wrap").css({"color": "#792809"}).text(message || "")
        )

        if(options?.additionalText) {
            message_compiled = message_compiled.append(
                $("<div>")
                    .attr("class", "mt-2 text-wrap")
                    .css({
                        "font-weight": 400,
                        "word-wrap": "break-word",
                        "color": "#792809"
                    })
                    .text(options.additionalText || "")
            )
        }

        message_compiled = message_compiled.html()

        ShowNotification.announce(message, options?.additionalText, false)

        // Notifyjs bug: if the first arg is undefined, it crashes.
        $.notify(message_compiled || "", ob)
    }

    /**
     * Shows an error message
     * @param {string} message
     * @param {{close?: boolean, href?: string, additionalText?: string} | null} [options]
     */
    static fail(message, options = null) {
        /** @type {{style: string, className: string, autoHide?: boolean}} */
        const ob = {
            style: "fail",
            className: "fail",
        }

        if(options && options.close) {
            ob.autoHide = false
        }

        let message_compiled = $("<p>").append(
            $("<span>").attr("class", "text-wrap").css({"color": "#A20C1B"}).text(message || "")
        )

        if(options && options.href) {
            // A link can't be reached by keyboard before a 5s auto-hide.
            ob.autoHide = false
            message_compiled = $("<p>").append(
                $("<a>")
                    .attr("href", options.href)
                    .css("color", "inherit")
                    .text(message || "")
            )
        }

        if(options?.additionalText) {
            message_compiled = message_compiled.append(
                $("<div>")
                    .attr("class", "mt-2 text-wrap")
                    .css({
                        "font-weight": 400,
                        "word-wrap": "break-word",
                        "color": "#A20C1B"
                    })
                    .text(options.additionalText || "")
            )
        }

        message_compiled = message_compiled.html()

        ShowNotification.announce(message, options?.additionalText, true)

        // Notifyjs bug: if the first arg is undefined, it crashes.
        $.notify(message_compiled, ob)
    }
}
